/*==================================================
=                 BMI ANAK (5–19)
==================================================*/

function calculateChildBMI(
    bmi,
    ageYears,
    sex,
    bmi05Data,
    bmi519Data
) {

    const month =
        Math.round(ageYears * 12);

    const genderKey =
        sex === "male"
            ? "boys"
            : "girls";

    const ref =
        bmi519Data?.[genderKey]?.[month] ||
        bmi05Data?.[genderKey]?.[month];

    if (!ref) {

        return {
            error:
                "Data referensi WHO untuk usia tersebut tidak ditemukan."
        };

    }

    const z =
        calculateZScore(
            bmi,
            ref
        );

    const percentile =
        zToPercentile(z);

    const result =
        classifyChildBMI(z);

    return {
        bmi: bmi,
        z: z,
        percentile: percentile,
        category: result.category,
        advice: result.advice,
        month: month
    };

}

function updateChildResult(result) {

    const childPercentile =
        document.getElementById(
            "child-percentile"
        );

    if (!childPercentile) {
        return;
    }

    let categoryClass =
        "underweight";

    switch (result.category) {

        case "Berat Badan Ideal":

            categoryClass =
                "healthy";

            break;

        case "Berisiko Kelebihan Berat Badan":

            categoryClass =
                "risk";

            break;

        case "Kelebihan Berat Badan":

            categoryClass =
                "overweight";

            break;

        case "Obesitas":

            categoryClass =
                "obese";

            break;

    }

    childPercentile.innerHTML = `
        <div class="bmi-category ${categoryClass}">
            ${result.category}
        </div>

        <div class="child-summary">
            <div>
                <strong>BMI</strong><br>
                ${result.bmi.toFixed(1)}
            </div>

            <div>
                <strong>Skor-Z</strong><br>
                ${result.z.toFixed(2)}
            </div>

            <div>
                <strong>Persentil</strong><br>
                ${result.percentile.toFixed(1)}%
            </div>
        </div>

        <div class="bmi-advice">
            <strong>Saran</strong>
            <p>${result.advice}</p>
        </div>
    `;

}

function drawChildChart(
    result,
    sex,
    bmi519Data
) {

    const genderKey =
        sex === "male"
            ? "boys"
            : "girls";

    if (
        !bmi519Data ||
        !bmi519Data[genderKey]
    ) {

        console.error(
            "Data grafik BMI WHO usia 5–19 tahun tidak tersedia."
        );

        return;

    }

    const curves =
        createWHOCurveData(
            bmi519Data,
            genderKey,
            "months"
        );

    if (!curves) {

        console.error(
            "Kurva BMI anak tidak dapat dibuat."
        );

        return;

    }

    const canvas =
        document.getElementById(
            "whoChart"
        );

    if (!canvas) {

        console.error(
            "Elemen grafik #whoChart tidak ditemukan."
        );

        return;

    }

    if (whoChart) {
        whoChart.destroy();
    }

    const datasets =
        buildWHOLineDatasets(curves);

    datasets.push({
        label: "Hasil Anak Anda",
        type: "scatter",

        data: [
            {
                x: result.month,
                y: result.bmi
            }
        ],

        pointRadius: 7,
        pointHoverRadius: 9,
        pointBackgroundColor: "#000000",
        pointBorderColor: "#ffffff",
        pointBorderWidth: 2
    });

    const title =
        document.getElementById(
            "who-chart-title"
        );

    if (title) {

        title.textContent =
            "Grafik BMI Menurut Usia WHO";

    }

    whoChart =
        new Chart(
            canvas.getContext("2d"),
            {
                type: "line",

                data: {
                    datasets: datasets
                },

                options: {
                    responsive: true,
                    maintainAspectRatio: false,

                    interaction: {
                        mode: "nearest",
                        intersect: false
                    },

                    plugins: {
                        legend: {
                            position: "bottom"
                        }
                    },

                    scales: {
                        x: {
                            type: "linear",

                            title: {
                                display: true,
                                text: "Usia (bulan)"
                            }
                        },

                        y: {
                            title: {
                                display: true,
                                text: "BMI"
                            }
                        }
                    }
                }
            }
        );

}